import { logInDev, isDev, isDeveloperDev } from "./isDev";

export const getIsSale = (discountConditon) => {
  if (isDeveloperDev) return true;

  const { startHour, endHour, startDay, endDay } = discountConditon;

  let isSale = false;
  const date = new Date();
  const dayIndex = date.getDay();
  const hour = date.getHours();
  logInDev("Today's Day Index: ", date.getDay());
  logInDev({
    "start day": dayIndex >= startDay,
    "end day": dayIndex < endDay,
    "start hour": hour >= startHour,
    "end hour": hour < endHour,
    "since 2020-04-14": date > new Date("2020-04-14"),
  });
  if (
    dayIndex >= startDay &&
    dayIndex <= endDay &&
    hour >= startHour &&
    hour < endHour &&
    date > new Date("2020-04-14")
  ) {
    isSale = true;
  }
  if (isDev) console.log(isSale);
  return isSale;
};
